export default "__VITE_ASSET__DESWMJaP__"